import { Platform } from "react-native";
import * as Sentry from "sentry-expo";

Sentry.init({
  dsn: "https://21483fbab52d4aeab989288e61c45ea4@o4504140778831872.ingest.sentry.io/4504892618244096",
  enableInExpoDevelopment: false,
  debug: process.env.NODE_ENV === "development",
  enableNative: Platform.OS !== "web",
});
